import { gql } from "@outschool/ui-apollo";

export const getS3FileUploadUrlMutation = gql`
  mutation getS3FileUploadUrl($fileName: String) {
    getS3FileUploadUrl(fileName: $fileName) {
      uploadUrl
      cdnUrl
    }
  }
`;
